import { postmultipart, post, form } from "@/utils/request";
import axios from "axios";

const TARGET_SERVER = process.env.VUE_ENV === "server";
const baseUrl = process.env.config.RRDH_HOST;

export default {
  uploadImg: query => postmultipart("/open/upload/uploadImg", query),
  uploadSaveImg: query => postmultipart("/rrbi/upload/uploadImg", query),
  uploadVideo: query => postmultipart("/open/upload/uploadAV", query),
  uploadBase64Img: query => post("/avatar/base64Upload", query),
  ccGetInfo: query => form("/open/course/ccgetInfo", query),
  ccUpload: query => post("/open/course/ccupload", query),
  ccCheck: query => post("/open/course/ccCheck", query),
  ccVideoInfo: query => post("/open/course/ccVideoInfo", query),

  videoDelete: id => post("/open/course/videoDelete/" + id),

  ccVideoInfoNew: vId => post("/rrbi/ccvideo/ccVideoInfo/" + vId),

  attaImgDelete: id => post("/rrbi/atta/attaImgDelete/" + id),
  attaVideoDelete: id => post("/rrbi/atta/attaVideoDelete/" + id),

  // ------------

  attaVideoInfo: id => post("/rrbi/atta/attaVideoInfo/" + id),
  addVideoForPro: query => post("/rrbi/atta/addVideoForPro", query),

  uploadBJYAV: query => postmultipart("/rrbi/upload/uploadBJYAV", query),

  weiboToken: code => post("/rrbi/getWeiboToken/"+code),

  getKeFu: getKeFu=> post("/kefu/admin/login/login.json"),
};
//
//
// //服务器渲染  数据获取
// export function fetchWeiboToken({ code, cookies }) {
//   return axios.post(baseUrl + `/rrbi/getWeiboToken/${code}`, {
//     headers: getCommonHeader({ cookies })
//   });
// }
//
// function getCommonHeader({ cookies }) {
//   if (TARGET_SERVER && cookies) {
//     return { cookie: getCookieString(cookies) };
//   } else {
//     return null;
//   }
// }
//
// function getCookieString(cookies) {
//   let cookieStr = "";
//   for (var variable in cookies) {
//     if (Object.prototype.hasOwnProperty.call(cookies, "variable")) {
//       cookieStr += `${variable}=${encodeURIComponent(cookies[variable])}; `;
//     }
//   }
//   return cookieStr;
// }
